import BatchMessages from './BatchMessages';

export default BatchMessages;
